import React from "react";
import SignatureCmp from "../../../components/Signature";

const Signature = () => (
  <div className="step-form">
    <SignatureCmp />
  </div>
);

export default Signature;


// WEBPACK FOOTER //
// ./src/containers/PickupForm/steps/Signature.js